// Messages domain slice. Origin/ownership rationale (WS-10.1, historyCleared):
// .claude/context/store-slices.md ("messagesSlice").
export const messagesSlice = (set) => ({
  messages: [],
  lastBotMessage: undefined,
  lastUserMessage: undefined,
  historyLoading: false,
  historyCleared: false,
  setMessages: (value) => set({ messages: value }),
  setLastBotMessage: (value) => set({ lastBotMessage: value }),
  setLastUserMessage: (value) => set({ lastUserMessage: value }),
  setHistoryLoading: (value) => set({ historyLoading: value }),
  setHistoryCleared: (value) => set({ historyCleared: value }),
});
